import styled from 'styled-components';
import { PopoverContent } from 'components/popovers/popover';

export const OverlayContent = styled(PopoverContent).attrs({
  className: 'w-[36rem] max-w-[calc(100vw-2rem)]',
})``;

export const IndicatorButton = styled.button.attrs({
  type: 'button',
  className:
    'relative flex h-8 w-8 items-center justify-center rounded-md transition-colors cursor-pointer hover:bg-muted/80',
})``;

export const Badge = styled.span.attrs({
  className:
    'absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-paused px-1 text-[10px] font-semibold text-paused-foreground',
})``;
